var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 10.9998C1.83333 7.54287 1.83333 5.81439 2.90727 4.74044C3.98122 3.6665 5.70969 3.6665 9.16666 3.6665H12.8333C16.2903 3.6665 18.0188 3.6665 19.0927 4.74044C20.1667 5.81439 20.1667 7.54287 20.1667 10.9998C20.1667 14.4568 20.1667 16.1853 19.0927 17.2592C18.0188 18.3332 16.2903 18.3332 12.8333 18.3332H9.16666C5.70969 18.3332 3.98122 18.3332 2.90727 17.2592C1.83333 16.1853 1.83333 14.4568 1.83333 10.9998Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24999 11.4583C6.98434 11.4583 5.95833 10.4323 5.95833 9.16667C5.95833 7.90102 6.98434 6.875 8.24999 6.875C9.51564 6.875 10.5417 7.90102 10.5417 9.16667C10.5417 10.4323 9.51564 11.4583 8.24999 11.4583ZM8.24999 11.4583C10.275 11.4583 11.9167 13.1 11.9167 15.125M8.24999 11.4583C6.22495 11.4583 4.58333 13.1 4.58333 15.125",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.25H17.4167",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11H17.4167",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.d999d145f911666983d0c1e1fa85870a.svg";
export { ForwardRef as ReactComponent };